import { render, staticRenderFns } from "./workForm.vue?vue&type=template&id=5bd69e16&scoped=true"
import script from "./workForm.vue?vue&type=script&lang=js"
export * from "./workForm.vue?vue&type=script&lang=js"
import style0 from "./workForm.vue?vue&type=style&index=0&id=5bd69e16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd69e16",
  null
  
)

export default component.exports